<div class="dropdown" [class.is-open]="open()">
  <button type="button" class="dropdown__trigger" (click)="toggle($event)">
    <span class="dropdown__value" [class.dropdown__value--all]="triggerLabel().all">{{ triggerLabel().text }}</span>
    <svg class="dropdown__arrow" viewBox="0 0 10 6" fill="none" aria-hidden="true">
      <path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </button>

  <div class="daterange-panel">
    <div class="dr-presets">
      <button type="button" class="dr-preset" (click)="applyPreset('all')">All dates</button>
      <button type="button" class="dr-preset" (click)="applyPreset('7')">Last 7 days</button>
      <button type="button" class="dr-preset" (click)="applyPreset('30')">Last 30 days</button>
      <button type="button" class="dr-preset" (click)="applyPreset('month')">This month</button>
    </div>

    <div class="dr-cal-head">
      <button type="button" class="dr-nav" (click)="prevMonth()" aria-label="Previous month">‹</button>
      <span class="dr-cal-title">{{ title() }}</span>
      <button type="button" class="dr-nav" (click)="nextMonth()" aria-label="Next month">›</button>
    </div>

    <div class="dr-grid">
      @for (dow of dowLabels; track dow) {
        <div class="dr-dow">{{ dow }}</div>
      }
      @for (cell of calendar(); track $index) {
        <button
          type="button"
          class="dr-day"
          [class.dr-day--blank]="cell.blank"
          [class.dr-day--in]="cell.inRange"
          [class.dr-day--start]="cell.start"
          [class.dr-day--end]="cell.end"
          [class.dr-day--today]="cell.today"
          [attr.tabindex]="cell.blank ? -1 : null"
          (click)="pick(cell)">
          @if (!cell.blank) {
            {{ cell.day }}
          }
        </button>
      }
    </div>

    <div class="dr-footer">
      <span class="dr-range-label">{{ rangeLabel() }}</span>
      <div>
        <button type="button" class="dr-clear" (click)="clear()">Clear</button>
        <button type="button" class="dr-done" (click)="done()">Done</button>
      </div>
    </div>
  </div>
</div>
